import { Inject, Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

import { BOOTSTRAP_DATA } from 'api/providers'
import { BootstrapData } from 'elements-sdk/src'
import { IdentityService } from 'main/services/identity.service'
import { LicenseService } from 'common/util/services/license.service'

@Injectable({ providedIn: 'root' })
export class MainConstants {
  cloudProviderIcons = {
    aws: '/assets/icons/aws.png',
    azure: '/assets/icons/azure.svg',
    backblaze: '/assets/icons/backblaze.png',
    gcloud: '/assets/icons/gcloud.svg',
  }

  validationPatterns = {
    email: /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\d\\a-z-]+\.)+[a-z]{2,}))$/i,
    variablesPresent: /{{.+}}/,
  }

  knownPages = this.identity.knownPages

  constructor (private identity: IdentityService) { }
}

@Injectable({ providedIn: 'root' })
export class NotificationConstants {
  types = {
    slack: 'Slack',
    teams: 'Teams',
    email: 'Email',
    push: 'Push',
    userPreferred: this.translate.instant('User preferred'),
  }
  topics = [
    {
      topic: 'default',
      name: this.translate.instant('All notifications'),
    }, {
      topic: 'comment/mention',
      name: this.translate.instant('Media Library > Mentioned in a comment'),
    }, {
      topic: 'comment/reply',
      name: this.translate.instant('Media Library > Comment reply'),
    }, {
      topic: 'comment/assigned',
      name: this.translate.instant('Media Library > Comment assigned'),
    }, {
      topic: 'comment/resolved',
      name: this.translate.instant('Media Library > Assignment resolved'),
    }, {
      topic: 'automation',
      name: this.translate.instant('Automation notifications'),
    }, {
      topic: 'click/upload/complete',
      name: this.translate.instant('Click > Upload > Finished'),
    }, {
      topic: 'click/upload/failed',
      name: this.translate.instant('Click > Upload > Failed'),
    },
  ]

  constructor (
    private translate: TranslateService,
    private license: LicenseService,
    @Inject(BOOTSTRAP_DATA) bootstrapData: BootstrapData,
  ) {
    if (!bootstrapData.cloudConnections.length) {
      this.topics = this.topics.filter(topic => !topic.topic.startsWith('click/'))
    }

    if (!license.hasComponent('media')) {
      this.topics = this.topics.filter(item => !item.topic.startsWith('comment'))
      this.topics = this.topics.filter(item => !item.topic.startsWith('automation'))
    }
  }
}
